import { sprint } from 'epubjs/lib/utils/core';

import { Section } from '../types/epubs';

export const SEARCH_CHARACTERS_TO_NORMALIZE = {
  '\u2018': "'", // Left single quotation mark
  '\u2019': "'", // Right single quotation mark
  '\u201A': "'", // Single low-9 quotation mark
  '\u201B': "'", // Single high-reversed-9 quotation mark
  '\u201C': '"', // Left double quotation mark
  '\u201D': '"', // Right double quotation mark
  '\u201E': '"', // Double low-9 quotation mark
  '\u201F': '"', // Double high-reversed-9 quotation mark
  '\u00BC': '1/4', // Vulgar fraction one quarter
  '\u00BD': '1/2', // Vulgar fraction one half
  '\u00BE': '3/4', // Vulgar fraction three quarters
};

const transformReplacement = Object.keys(SEARCH_CHARACTERS_TO_NORMALIZE).join(
  ''
);
const normaliseTransformPattern = new RegExp(
  '[' + transformReplacement + ']',
  'g'
);

const normaliseString = (str: string) =>
  str.replace(
    normaliseTransformPattern,
    (ch) => SEARCH_CHARACTERS_TO_NORMALIZE[ch]
  );

export const findInSection = (
  section: Section,
  caseSensitive: boolean,
  rawQuery: string
) => {
  const normalisedQuery = normaliseString(
    caseSensitive ? rawQuery : rawQuery.toLowerCase()
  );
  const matches = [] as Array<{ cfi: string; excerpt: string }>;

  const find = (node: Node) => {
    const textContent = node.textContent;
    const sectionDocument = section.document;
    if (!textContent || !sectionDocument) {
      return;
    }
    const text = normaliseString(
      caseSensitive ? textContent : textContent.toLowerCase()
    );
    let range = sectionDocument.createRange();
    let cfi;
    let pos;
    let last = -1;
    let excerpt;
    const limit = 150;

    while (pos !== -1) {
      // Search for the query
      pos = text.indexOf(normalisedQuery, last + 1);

      if (pos !== -1) {
        // We found it! Generate a CFI
        range = sectionDocument.createRange();
        range.setStart(node, pos);
        range.setEnd(node, pos + normalisedQuery.length);

        cfi = section.cfiFromRange(range);

        // Generate the excerpt
        if (textContent.length < limit) {
          excerpt = textContent;
        } else {
          excerpt = textContent.substring(pos - limit / 2, pos + limit / 2);
          excerpt = '...' + excerpt + '...';
        }

        // Add the CFI to the matches list
        matches.push({
          cfi,
          excerpt,
        });
      }

      last = pos;
    }
  };

  sprint(section.document, (node: Node) => {
    find(node);
  });

  return matches;
};
